import { type MyAccountDataJSP, type MyAccountData } from "./myAccountTypes";
import { AFFILIATE_FORM_KEY } from "~/feature/Affiliate/AffiliateFormSection";
import { transformSalesPartnerDTO } from "~/feature/Affiliate/utils";
import { getSavedAffiliatePartner_toBeRemoved } from "~/feature/Affiliate/utilsToRefactorOut";

export function transformMyAccountData(dto: MyAccountDataJSP): MyAccountData {
  const { titleCode, salutationCode, line1, line2, isSalesPartnerSaved, selectedSubsidiary, ...inputFieldValues } =
    dto.inputFieldValues;
  return {
    ...dto,
    inputFieldValues: {
      ...inputFieldValues,
      title: titleCode,
      salutation: salutationCode,
      address: line1,
      addressAdditional: line2,
      oldPassword: "", //field
      newPassword: "",
      newPasswordConfirmation: "",
      privacyPolicy: dto.privacyPolicy,
      termsTraining: false,
      [AFFILIATE_FORM_KEY]: {
        id: isSalesPartnerSaved ? getSavedAffiliatePartner_toBeRemoved()?.affiliateId ?? "" : "",
        subsidiary: selectedSubsidiary,
      },
    },
    affiliates: dto.affiliates.map(transformSalesPartnerDTO),
  };
}
